/**
 * NSE/BSE equity session state, derived from the clock — no API call, and no
 * pretending to know more than we do. Replaces the previously fabricated
 * "NSE LIVE" indicator.
 */

export type SessionState = 'pre-open' | 'open' | 'closed' | 'weekend';

export interface MarketSession {
  state: SessionState;
  label: string;
  /** true only during continuous trading */
  isLive: boolean;
}

/** Minutes since IST midnight, independent of the viewer's timezone. */
function istMinutes(now: Date): { minutes: number; weekday: number } {
  const ist = new Date(now.getTime() + (330 + now.getTimezoneOffset()) * 60_000);
  return { minutes: ist.getHours() * 60 + ist.getMinutes(), weekday: ist.getDay() };
}

export function getMarketSession(now: Date = new Date()): MarketSession {
  const { minutes, weekday } = istMinutes(now);

  if (weekday === 0 || weekday === 6) {
    return { state: 'weekend', label: 'Market closed', isLive: false };
  }
  if (minutes >= 9 * 60 && minutes < 9 * 60 + 15) {
    return { state: 'pre-open', label: 'Pre-open', isLive: false };
  }
  if (minutes >= 9 * 60 + 15 && minutes <= 15 * 60 + 30) {
    return { state: 'open', label: 'Market open', isLive: true };
  }
  return { state: 'closed', label: 'Market closed', isLive: false };
}
